import React, {useRef, useState} from 'react';
import contact from "../Images/Contact.jpg";

const Contact = () => {
    const dataRef = useRef({name:"", email:"", phone:"", description:""})
    const loginURL = "https://interperfectemailrelay.herokuapp.com/api/v1/emails/contact";
    /*const loginURL = "http://localhost:7000/api/v1/emails/contact";*/
    const [message, setMessage] = useState("");

    async function handleSubmit(event){
        event.preventDefault();
        const name = event.target.name.value;
        const email = event.target.email.value;
        const phone = event.target.phone.value;
        const description = event.target.description.value;
        dataRef.current = {name: name, email: email, phone: phone, description: description};
        const fetchOptions = {
            method: "POST",
            mode:"cors",
            cache: "default",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            },
            redirect: "follow",
            body: JSON.stringify(dataRef.current),
            referrerPolicy: 'no-referrer'
        }
        try{
        setMessage("Sending Contact Form, Please Wait.")
        const response = await fetch(loginURL, fetchOptions)
        const data = await response.json()
        setMessage(data.message);
        }catch(error){
            console.error(`Error: ${error}`);
        }
    }
    return(
        <div className="overflow-hidden relative">
            <section className="banner contact-land">
                <img src={contact} className="image" alt=""/>
            </section>
            <h1 className="contact-header">Get a Quote Today!</h1>
            <section className="section contact-us">
                <div className="form-container">
                    <form className="form" onSubmit={(event) => handleSubmit(event)}>
                        {message && 
                        <h2 className="">
                            {message}
                        </h2>
                        }
                        <div className="input-section">
                            <label htmlFor="name" className="input-label">
                                Full Name <span className="required">*</span>
                            </label>
                            <input required type="text" className="text-input" name="name" id="name" placeholder="Full Name"/>
                        </div>
                        <div className="input-section">
                            <label htmlFor="email" className="input-label">
                                Email Address <span className="required">*</span>
                            </label>
                            <input required type="email" className="text-input" name="email" id="email" placeholder="Email"/>
                        </div>
                        <div className="input-section">
                            <label htmlFor="phone" className="input-label">
                                Phone Number
                            </label>
                            <input type="tel" className="text-input" name="phone" id="phone" placeholder="(555) 555-5555"/>
                        </div>
                        <div className="input-section">
                            <label htmlFor="description" className="input-label">
                                Message
                            </label>
                            <textarea type="text" className="text-area" name="description" id="description" required placeholder="I'm Interested in having some windows installed." rows={8} patter="[a-zA-Z0-9.?]"/>
                        </div>
                        <div className="input-section">
                            <input type="submit" className="submit" value="Submit"/>
                        </div>
                    </form>
                </div>
                <div className="map-container">
                    <h2 className="map-header"> Find us here! </h2>
                    <iframe title="google maps" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3017.906144490624!2d-73.97069154866975!3d40.85198437921533!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f6c401c9f7fb%3A0x8afb3316126a8d7a!2s2030%20Hudson%20St%2C%20Fort%20Lee%2C%20NJ%2007024!5e0!3m2!1sen!2sus!4v1636488712745!5m2!1sen!2sus" allowfullscreen="" className="map" loading="lazy"/>
                    <div className="contact">
                        <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
                        <span className="info"> 2030 Hudson Street</span>
                    </div>
                    <div className="contact succ">
                        <span className="info-cont"> Fort Lee, NJ 07024</span>
                    </div>
                    <div className="contact">
                        <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                        <span className="info"> <a href="tel:2013286323"> 201-328-6323 </a> <br/>
                        </span>
                    </div>
                </div>

            </section>
        </div>
    )
}

export default Contact;